import { api } from "..";
import { SendMessagePayload, SendMessageResponse } from "./types";

export const sendMessage = async (
  payload: SendMessagePayload
): Promise<SendMessageResponse> => {
  const res = await api.client.post("/chats/messages", payload);
  return res.data;
};
